// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchBar_container__1WtMC","icon":"SearchBar_icon__z3MS4","input":"SearchBar_input__2EHFN"};